module.exports = __webpack_public_path__ + "static/media/instruments.d1a216d5.svg";